import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DialogNames } from 'redux-implementations/dialog';
import State from 'types/State';

import useDialog from './useDialog';
import useSaveSearch from './useSaveSearch';
import useSrpMobileSidebar from './useSrpMobileSidebar';

export default function useOpenFilterModal(): {
  setOpenModalOnSignIn: Dispatch<SetStateAction<boolean | null>>;
  savedSearchId: number;
} {
  const [openModalOnSignIn, setOpenModalOnSignIn] = useState<boolean | null>(null);
  const [savedSearchId, setSavedSearchId] = useState(0);
  const { toggle: toggleFiltersModal } = useSrpMobileSidebar();
  const { isShown } = useDialog(DialogNames.Auth);
  const { saveSearch } = useSaveSearch();
  const isSignedIn = useSelector<State>((state) => state?.session?.isSignedIn);

  async function getSaveSearchId(): Promise<void> {
    const res = await saveSearch();
    setSavedSearchId(res.id);
  }

  useEffect(() => {
    if (isShown && isSignedIn && openModalOnSignIn) {
      getSaveSearchId();
      toggleFiltersModal();
      setOpenModalOnSignIn(null);
    }

    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShown, isSignedIn, openModalOnSignIn]);

  return { setOpenModalOnSignIn, savedSearchId };
}
